import { Flex, Text } from "@radix-ui/themes";
import { useI18n } from "@/i18n";

/** Calm, neutral placeholder for a genuinely-empty-but-valid period. Never styled as an error. */
export function EmptyState() {
  const { t } = useI18n();
  return (
    <Flex direction="column" align="center" justify="center" gap="3" className="rk-state-panel rk-state-empty">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" aria-hidden="true">
        <rect x="3" y="4" width="18" height="17" rx="1.5" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="8" y1="2.5" x2="8" y2="5.5" />
        <line x1="16" y1="2.5" x2="16" y2="5.5" />
      </svg>
      <Text size="2" color="gray" align="center" style={{ maxWidth: 440 }}>
        {t("state.empty")}
      </Text>
    </Flex>
  );
}
